// eslint-disable-next-line import/prefer-default-export
export const MAX_YOUTUBE_THUMBNAIL = 'maxresdefault';
export const PREVENT_BLACK_LINES_RESERVE = 0.1;
export const YOUTUBE_BRANDING_RESERVE = 100;
export const YOUTUBE_RATIO = +(16 / 9).toFixed(2);
export const VIDEO_RESIZE_DEBOUNCE = 100;
